export default __webpack_public_path__ + "f56e437afb546a89b5e8a5035db9773a.png";